export const SET_PERSONAL_DETAILS_UI_ELEMENT_STATES =
	'SET_PERSONAL_DETAILS_UI_ELEMENT_STATES';
export const RESET_PERSONAL_DETAILS_UI_ELEMENT_STATES =
	'RESET_PERSONAL_DETAILS_UI_ELEMENT_STATES';
